import { render, staticRenderFns } from "./registrationFee.vue?vue&type=template&id=71cb0081&scoped=true"
import script from "./registrationFee.vue?vue&type=script&lang=js"
export * from "./registrationFee.vue?vue&type=script&lang=js"
import style0 from "./registrationFee.vue?vue&type=style&index=0&id=71cb0081&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb0081",
  null
  
)

export default component.exports